/**
 * NOTE: This file is part of the legacy Notes feature.
 * User-facing text has been renamed to "Documentation" for clarity.
 * For the new Notes feature, check the Hub implementation.
 */

import {
  NoteCard,
  NoteCardProps,
} from "@/components/conversation-details/notes/note-card";
import { cn } from "@/lib/utils";
import { CalendarIcon, PencilIcon, PinIcon, PlusIcon } from "lucide-react";

export type HeadingType = "reminder" | "created" | "pinned" | "new";

interface NoteTimelineItemProps extends NoteCardProps {
  heading: string;
  headingType: HeadingType;
}

export function NoteTimelineItem({
  heading,
  headingType,
  isNew,
  ...props
}: NoteTimelineItemProps) {
  return (
    <div
      className={cn(
        "inline-flex w-full flex-col items-start justify-start gap-2.5 [&:not(:first-child)]:mt-4",
        {
          "cursor-not-allowed": props?.readonlyMode,
        },
      )}
    >
      <div className="inline-flex items-center justify-start gap-2.5 self-stretch">
        <div className="flex items-center justify-start gap-2.5">
          <div className="flex items-center justify-start gap-2.5 rounded bg-indigo-100">
            <div className="flex items-center justify-start gap-2.5 p-1">
              {headingType === "new" ? (
                <PlusIcon size={12} />
              ) : headingType === "reminder" ? (
                <CalendarIcon size={12} />
              ) : headingType === "pinned" ? (
                <PinIcon size={12} />
              ) : (
                <PencilIcon size={12} />
              )}
            </div>
          </div>
          <div className="text-xs font-normal text-stone-500">{heading}</div>
        </div>
      </div>
      <div className="inline-flex items-start justify-start gap-2.5 self-stretch">
        <div className="flex w-4 items-start justify-start gap-2.5 self-stretch px-2">
          <div className="w-20 origin-top-left rotate-0 self-stretch border border-zinc-300"></div>
        </div>
        <NoteCard isNew={isNew} {...props} />
      </div>
    </div>
  );
}
